var space = {
  0: 0,
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 24,
  6: 32,
  7: 40,
  8: 64,
  9: 80
};
space.xxxs = space[1];
space.xxs = space[2];
space.xs = space[3];
space.s = space[4];
space.m = space[5];
space.l = space[6];
space.xl = space[7];
space.xxl = space[8];
space.xxxl = space[9];
export default space;